import styled from "styled-components";
import { Typography } from "components/Typography";
import { colors } from "styles/colors";

export const ErrorLabelStyled = styled(Typography)(() => ({
  color: colors.error,
  margin: "0 14px 0 !important",
  paddingTop: "4px",
}));
